/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

// Import all style variables from module.scss files
import * as colorsModule from 'ui/styles/colors.module.scss';
import * as fontSizesModule from 'ui/styles/font-sizes.module.scss';
import * as fontWeightsModule from 'ui/styles/font-weights.module.scss';
import * as sizesModule from 'ui/styles/sizes.module.scss';

// Direct export of SCSS modules
export const colors = colorsModule;
export const fontSize = fontSizesModule;
export const fontWeight = fontWeightsModule;
export const sizes = sizesModule;

export { mapStyles } from './map-styles';
